<template>
  <v-content class="pa-0">
    <v-row justify="space-around">
        
        <v-snackbar v-model="snackbar" :timeout="4000" top :color="color" > {{text}}
          <v-btn color="white" text @click="snackbar = false" > Cerrar  </v-btn>
        </v-snackbar>

        <v-col cols="12" sm="6" md="5" lg="4" xl="3">
          <v-toolbar color="primary" dark>
            <v-toolbar-title > Olvide mi contraseña </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn  text color="white" x-small fab dark :to="{name: 'Login'}"><v-icon>reply</v-icon></v-btn>
          </v-toolbar>

           <v-card-text class="mt-2" align="center">
              <img src="https://support-smipack.com/fotos/logo.png" width="200" height="80%" class="mb-5" >
                <v-form ref="form" v-model="valid" >
                  <v-row>
                    <v-col cols="12" > 
                      <v-text-field
                        autofocus
                        v-model="email" 
                        :rules="emailRules"
                        prepend-icon="email" 
                        label="Correo electronico" 
                        required
                        dense
                        outlined>
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              <v-card-actions> <v-spacer></v-spacer>
              <v-btn :disabled="!valid" small color="secondary" @click="ValidarCorreo()">Actualizar</v-btn></v-card-actions>
            </v-card-text>
            
        </v-col>
    </v-row>
	</v-content>
</template>

<script>
import router from '@/router'
import {mapActions , mapGetters} from 'vuex'
  export default {
    data(){
      return{
        valid:false,
        email:'',
        random:1,
        letraRandom:'',
        snackbar: false,
        timeout: 8000,
        text: '',
        color:'yellow darken-2',
         emailRules: [v => !!v || 'Es requerido', v => /.+@.+\..+/.test(v) || 'E-mail no es valido'],
        letras:['A','b','a','z','X','W','v','F','H','s','U']
      }
    },

    created(){
    },

    computed:{
    },

    methods:{

      formarCodigo(){
        var codigo = this.letras[Math.floor(Math.random() * 10)];
          for(let i=0;i<3;i++){
           var numero  = Math.floor(Math.random() * 10);
           var numero2 = Math.floor(Math.random() * 10);
           var letra  = this.letras[Math.floor(Math.random() * 10)]
           codigo = codigo + numero + numero2 + letra
          }
          return codigo;
      },

      ValidarCorreo(){
      	const payload= {  email: this.email }
          this.$http.post('olvida.contra', payload).then(response =>{
            if(!response.body.length){
              this.snackbar= true ; this.text="Esté correo no es valido." ; 
              this.email = '';
            }else{
              const payload = {
              	id      : response.body[0].idusuariosweb,
              	nomuser : response.body[0].nombre,
              	email   : response.body[0].email,
                url    : "https://support-smipack.com/#/",
                codigo  : this.formarCodigo()
              }
              this.ActualizaPassExtra(payload);
              this.Enviarcorreo(payload)
            }
          }).catch(function(error){console.log('error',error)})	
      },

      ActualizaPassExtra(usuario){
        var md5 = require('md5');
        const payload = { id: usuario.id, codigo: md5(usuario.codigo) }

        this.$http.post('password.extra',payload).then(response =>{
          console.log('pass extra', response.body)
        }).catch(err =>{
          console.log('err',err)
        })
      },

      Enviarcorreo (payload){
				this.$http.post('send.contra',payload).then((response)=>{
          console.log('Entre a eviar correo')
	        if(response.status == 200){
	        	this.color = 'success'
	        	this.snackbar = true
	        	this.text = 'Se ha enviado el correo de validacion a su cuenta.'
	        	this.to=''
	        	this.subject=''
	        	this.cuerpo=''
	        }else{
	        	this.color = 'red'
	        	this.snackbar = true
	        	this.text = 'Falla al enviar el correo'
	        	this.to=''
	        	this.subject=''
	        	this.cuerpo=''
	        }  
          var me = this
          // Mandar a login
          setTimeout(function(){ me.$router.push({name: 'Login'}) }, 3000);
	      })

	  	},
    }
  };


</script>
